<div class="dialog-header" cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>
    <h2 mat-dialog-title>{{ title }}</h2>
    <mat-icon>drag_indicator</mat-icon>
</div>
<mat-dialog-content class="dialog-content">
    <div>
        <app-ad-group-chooser [formControl]="adGroupFilter" label="AD group names (press enter after each)"
            [selectedADGroups]="selectedADGroups" (adGroupsChange)="adGroupsChange($event)"></app-ad-group-chooser>
    </div>
    <mat-selection-list [(ngModel)]="selectedOptions"
        [compareWith]="itemComparer" (ngModelChange)="log($event)" >
        @for (member of flattenedMembers; track member) {
            <mat-list-option [value]="member">{{ getItemName(member) }}</mat-list-option>
        }
    </mat-selection-list>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-button (click)="cancel()">Cancel</button>
    <button mat-flat-button [disabled]="! adGroupFilter.value?.length" (click)="addMembers()"><mat-icon>add</mat-icon>Add members</button>
</mat-dialog-actions>